import { render, staticRenderFns } from "./CohortTable.vue?vue&type=template&id=40be18a4&scoped=true"
import script from "./CohortTable.vue?vue&type=script&lang=js"
export * from "./CohortTable.vue?vue&type=script&lang=js"
import style0 from "./CohortTable.vue?vue&type=style&index=0&id=40be18a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be18a4",
  null
  
)

export default component.exports